import {
  sorteeLandingFaq,
  sorteeLandingFeatures,
  sorteeLandingHow,
} from './sorteeLandingContent'

export const premiumFeatures = [
  { key: 'dashboard', icon: 'dashboard' as const, ...sorteeLandingFeatures.dashboard },
  { key: 'roulette', icon: 'wheel' as const, ...sorteeLandingFeatures.roulette },
  { key: 'gateway', icon: 'payment' as const, ...sorteeLandingFeatures.gateway },
  { key: 'capi', icon: 'target' as const, ...sorteeLandingFeatures.capi },
  { key: 'draw', icon: 'star' as const, ...sorteeLandingFeatures.draw },
  { key: 'affiliates', icon: 'people' as const, ...sorteeLandingFeatures.affiliates },
  { key: 'campaigns', icon: 'page' as const, ...sorteeLandingFeatures.campaigns },
].map((feature) => ({
  ...feature,
  highlight: feature.description.split('. ')[0],
  tag: feature.title.toUpperCase(),
}))
export const premiumSteps = sorteeLandingHow.steps.map((step) => ({
  ...step,
  highlight:
    step.title === 'Crie a campanha'
      ? 'Nome, slug, prêmios e quantidade de números'
      : step.title === 'Divulgue e venda'
        ? 'PIX, cartão ou boleto'
        : 'sorteio automático',
  detail: step.cardTitle,
}))
export const premiumFaq = sorteeLandingFaq.items.map((item) => ({
  ...item,
  highlight: item.answer.split('. ')[0],
}))
